module.exports = __webpack_public_path__ + "static/media/business.b298e81c.jpg";